"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useCallback, useRef, useState } from "react";
import { Box, chakra, Drawer, IconButton, Portal, useDisclosure } from "@chakra-ui/react";
import { FaAngleLeft, FaAngleRight } from "react-icons/fa";
const AngleLeft = chakra(FaAngleLeft);
const AngleRight = chakra(FaAngleRight);
interface DrawerProps {
  children: React.ReactNode;
  title: string;
  footerText: React.ReactNode;
}
const SHDrawer = t0 => {
  const $ = _c(16);
  const {
    children,
    title,
    footerText
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      defaultOpen: true
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    open,
    onOpen,
    onClose
  } = useDisclosure(t1);
  const drawerContainerRef = useRef(null);
  const [drawerContainer, setDrawerContainer] = useState(null);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = node => {
      drawerContainerRef.current = node;
      setDrawerContainer(node);
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const setContainer = t2;
  let t3;
  if ($[2] !== drawerContainer || $[3] !== onOpen || $[4] !== open) {
    t3 = drawerContainer && !open && <Portal container={drawerContainerRef}><Box position="absolute" zIndex="overlay" top={{
        base: "auto",
        md: "0"
      }} left="0" bottom="0" right={{
        base: "0",
        md: "auto"
      }} w={{
        base: "auto",
        md: "5"
      }} h={{
        base: "5",
        md: "auto"
      }} backgroundColor="white"><Box onClick={onOpen} asChild={true} position="absolute" left={{
          base: "0",
          md: "0"
        }} right={{
          base: "0",
          md: "auto"
        }} bottom={{
          base: "0",
          md: "auto"
        }} top={{
          base: "auto",
          md: "1/2"
        }} w={{
          base: "fit",
          md: "auto"
        }} mx={{
          base: "auto",
          md: "0"
        }} transform={{
          base: "none",
          md: "translateY(-50%)"
        }}><IconButton variant="subtle" rounded="full" size="md"><AngleRight rotate={{
              base: "270deg",
              md: "0deg"
            }} /></IconButton></Box></Box></Portal>;
    $[2] = drawerContainer;
    $[3] = onOpen;
    $[4] = open;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== children || $[7] !== drawerContainer || $[8] !== footerText || $[9] !== onClose || $[10] !== open || $[11] !== title) {
    t4 = drawerContainer && <Drawer.Root placement={{
      mdDown: "bottom",
      md: "start"
    }} open={open} onOpenChange={details => {
      if (!details.open) {
        onClose();
      }
    }} modal={false} closeOnInteractOutside={false} lazyMount={true}><Portal container={drawerContainerRef}><Drawer.Positioner h="full" w="full" position="absolute" pointerEvents="none"><Drawer.Content w={{
            base: "full",
            md: "sm"
          }} maxW={{
            base: "full",
            md: "sm"
          }} h={{
            base: "1/2",
            md: "full"
          }} maxH={{
            base: "1/2",
            md: "full"
          }} pointerEvents="auto" css={{
            "&[data-state='open']": {
              animationName: "none"
            }
          }}><Drawer.CloseTrigger onClick={onClose} asChild={true} position="absolute" left={{
              base: "0",
              md: "auto"
            }} right={{
              base: "0",
              md: "-5"
            }} top={{
              base: "-5",
              md: "1/2"
            }} w={{
              base: "fit",
              md: "auto"
            }} mx={{
              base: "auto",
              md: "0"
            }} transform={{
              base: "none",
              md: "translateY(-50%)"
            }}><IconButton variant="subtle" rounded="full" size="md"><AngleLeft rotate={{
                  base: "270deg",
                  md: "0deg"
                }} /></IconButton></Drawer.CloseTrigger><Drawer.Header><Drawer.Title>{title}</Drawer.Title></Drawer.Header><Drawer.Body>{children}</Drawer.Body><Drawer.Footer>{footerText}</Drawer.Footer></Drawer.Content></Drawer.Positioner></Portal></Drawer.Root>;
    $[6] = children;
    $[7] = drawerContainer;
    $[8] = footerText;
    $[9] = onClose;
    $[10] = open;
    $[11] = title;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== t3 || $[14] !== t4) {
    t5 = <Box ref={setContainer}><>{t3}{t4}</></Box>;
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  return t5;
};
export default SHDrawer;